import client from "services/ngage/api-client";
import {TrailWaypoint} from "types/TrailWaypoint";
import deserializeTrailWaypoint from "services/ngage/deserializers/trail-waypoint";
import DataResource from "types/DataResource";
import {snakeKeys} from "services/array";

type TrailWaypointFilters = {
    search?: string | null
    page?: number
    perPage?: number
}

/**
 * Get all trail waypoints that match the given filters (paginated)
 */
const filtered = async (trailId: number, filters: TrailWaypointFilters = {}) => {
    const params = Object.assign({page: 1, per_page: 100}, snakeKeys(filters))

    try {
        const page = (await client.get<DataResource<TrailWaypoint> | null>(`/trails/${trailId}/waypoints`, {params})).data

        if (page) page.data = page.data.map(deserializeTrailWaypoint)

        return page
    } catch (error) {
        console.error("Unable to fetch trail waypoints", error)
        return null
    }
}

const trailWaypoints = {
    filtered,
}

export default trailWaypoints;